import { CalendarEventChip } from '@/modules/calendar/components/CalendarEventChip';
import type { CalendarEvent } from '@/modules/calendar/types';
import {
  eventsForDay,
  formatDayNumber,
  formatWeekday,
  getWeekDayIsos,
} from '@/modules/calendar/utils';

type CalendarWeekViewProps = {
  anchorDate: string;
  events: CalendarEvent[];
};

export function CalendarWeekView({ anchorDate, events }: CalendarWeekViewProps) {
  const days = getWeekDayIsos(anchorDate);

  return (
    <div className="calendar-week">
      {days.map((iso) => {
        const dayEvents = eventsForDay(events, iso);
        return (
          <div key={iso} className="calendar-week__col">
            <header className="calendar-week__header">
              <span className="calendar-week__weekday">{formatWeekday(iso)}</span>
              <span className="calendar-week__day">{formatDayNumber(iso)}</span>
            </header>
            <div className="calendar-week__events">
              {dayEvents.length === 0 ? (
                <span className="auth-muted">—</span>
              ) : (
                dayEvents.map((ev) => (
                  <CalendarEventChip key={ev.id} event={ev} />
                ))
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
